import client from '@/graphql/client'
import SaveGitHubToken from '@/graphql/mutations/SaveGitHubToken'
import RemoveGitHubToken from '@/graphql/mutations/RemoveGitHubToken'
import ListGitHubRepos from '@/graphql/queries/ListGitHubRepos'
import CreateGitHubRepo from '@/graphql/mutations/CreateGitHubRepo'
import InitGitHubRepo from '@/graphql/mutations/InitGitHubRepo'
import ListGitHubRepoFiles from '@/graphql/queries/ListGitHubRepoFiles'
import ListGitHubRepoBranches from '@/graphql/queries/ListGitHubRepoBranches'
import FetchGitHubRepoFileContent from '@/graphql/queries/FetchGitHubRepoFileContent'
import CommitGitHubRepoFiles from '@/graphql/mutations/CommitGitHubRepoFiles'
import DeleteGitHubRepo from '@/graphql/mutations/DeleteGitHubRepo'

export const github = {
  namespaced: true,
  state: {
    githubAccounts: []
  },
  mutations: {
    setGithubAccounts (state, payload) {
      state.githubAccounts = payload || []
    }
  },
  actions: {
    async saveGitHubToken ({ commit }, { code }) {
      const res = await client.query({
        operationName: 'saveGitHubToken',
        query: SaveGitHubToken,
        variables: {
          code
        }
      })
      const result = res.saveGitHubToken

      if (result?.success && result?.resData?.githubAccounts) {
        commit('setGithubAccounts', result.resData.githubAccounts || [])
      }

      return result
    },
    async removeGitHubToken ({ commit }, { username }) {
      const res = await client.query({
        operationName: 'removeGitHubToken',
        query: RemoveGitHubToken,
        variables: {
          username
        }
      })
      const result = res.removeGitHubToken

      if (result?.success && result?.resData?.githubAccounts) {
        commit('setGithubAccounts', result.resData.githubAccounts || [])
      }

      return result
    },
    async listGitHubRepos ({ commit }, { login, pageUrl }) {
      const res = await client.query({
        operationName: 'listGitHubRepos',
        query: ListGitHubRepos,
        variables: {
          login,
          pageUrl
        }
      })
      return res.listGitHubRepos
    },
    async listGitHubRepoBranches ({ commit }, { login, owner, repo, pageUrl }) {
      const res = await client.query({
        operationName: 'listGitHubRepoBranches',
        query: ListGitHubRepoBranches,
        variables: { login, owner, repo, pageUrl }
      })
      return res.listGitHubRepoBranches
    },
    async createGitHubRepo ({ commit }, { login, repo, description, isPrivate }) {
      const res = await client.query({
        operationName: 'createGitHubRepo',
        query: CreateGitHubRepo,
        variables: { login, repo, description, isPrivate }
      })
      return res.createGitHubRepo
    },
    async initGitHubRepo ({ commit }, { login, owner, repo, branch, filePath, content, message }) {
      const res = await client.query({
        operationName: 'initGitHubRepo',
        query: InitGitHubRepo,
        variables: { login, owner, repo, branch, filePath, content, message }
      })
      return res.initGitHubRepo
    },
    async listGitHubRepoFiles ({ commit }, { login, owner, repo, folder, branch }) {
      const res = await client.query({
        operationName: 'listGitHubRepoFiles',
        query: ListGitHubRepoFiles,
        variables: { login, owner, repo, folder, branch }
      })
      return res.listGitHubRepoFiles
    },
    async fetchGitHubRepoFileContent ({ commit }, { login, owner, repo, files, branch }) {
      const res = await client.query({
        operationName: 'fetchGitHubRepoFileContent',
        query: FetchGitHubRepoFileContent,
        variables: { login, owner, repo, files, branch }
      })
      return res.fetchGitHubRepoFileContent
    },
    async commitGitHubRepoFiles ({ commit }, { login, owner, repo, branch, files, message }) {
      const res = await client.query({
        operationName: 'commitGitHubRepoFiles',
        query: CommitGitHubRepoFiles,
        variables: { login, owner, repo, branch, files, message }
      })
      return res.commitGitHubRepoFiles
    },
    async deleteGitHubRepo ({ commit }, { login, owner, repo }) {
      const res = await client.query({
        operationName: 'deleteGitHubRepo',
        query: DeleteGitHubRepo,
        variables: { login, owner, repo }
      })
      return res.deleteGitHubRepo
    }
  }
}
